// extracted by mini-css-extract-plugin
export default {"conteneur_confirmation_commande":"confirmation-commande_conteneur_confirmation_commande__L5KsV","item_panier":"confirmation-commande_item_panier__qT+UR"};